import { useMutation, useQuery } from '@apollo/client';
import { message } from 'antd';
import {
  CasesIdentityVerificationV1ChatPageContainerStaffUserCurrentDocument,
  IdentityVerificationCaseV1UpdateInput,
  StaffChatPageContainerIdentityVerificationCaseV1QueryDocument,
  StaffChatPageContainerIdentityVerificationCaseV1UpdateDocument
} from '../../../../../../generated';
import { useOid } from '../../../../../../hooks/useOid';
import ChatPage, { CaseData } from '../../../../../shared/chat/chat-page';
import { ComponentQueryLoader } from '../../../../../shared/component-query-loader';
import { getStaffUserCurrentQueryOptionsWithOidAndCacheDisabled } from '../../../../../shared/utils/queryOptions';

const requestObject = {
  requestUpdatedPassportDetails: false,
  requestUploadExpirationPage: false,
  requestUploadPassport: false,
  requestUploadPassportTranslation: false,
  requestUploadPhoto: false,
  requestScheduleNotaryCam: false,
  requestUploadNotarizedIdForm: false
};

interface ChatPageContainerProps {
  caseId: string;
  isCaseOrApplicant: string;
}

export const ChatPageContainer: React.FC<ChatPageContainerProps> = (props) => {
  const oid = useOid();
const staffUserCurrentQueryOptions = getStaffUserCurrentQueryOptionsWithOidAndCacheDisabled(oid);
  const {
    data: queryData,
    loading,
    error
  } = useQuery(StaffChatPageContainerIdentityVerificationCaseV1QueryDocument, {
    variables: {
      identityVerificationCaseV1Id: props.caseId
    }
  });

  const [updateMessages] = useMutation(StaffChatPageContainerIdentityVerificationCaseV1UpdateDocument);
  const {
    data: staffData,
    loading: staffLoading,
    error: staffError
  } = useQuery(CasesIdentityVerificationV1ChatPageContainerStaffUserCurrentDocument,staffUserCurrentQueryOptions);

  const handleSave = async (values: any) => {
    let inputData: IdentityVerificationCaseV1UpdateInput = {
      id: props.caseId,
      messages: values?.messages
    };

    if (values?.revisionRequest) {
      inputData.revisionRequest = {
        ...values?.revisionRequest
      };
    }

    if (values?.financeDetails) {
      inputData.financeDetails = {
        ...values?.financeDetails
      };
    }
    if (values?.adhocPayment) {
      inputData.adhocPayment = {
        ...values?.adhocPayment
      };
    }
    try {
      const result = await updateMessages({
        variables: {
          input: inputData
        }
      });
      if (result.data?.identityVerificationCaseV1Update?.status.success) {
        if (result.data?.identityVerificationCaseV1Update.identityVerificationCaseV1 && values?.financeDetails) {
          const adhocTransaction = result?.data?.identityVerificationCaseV1Update?.identityVerificationCaseV1?.financeDetails?.transactions?.adhocTransactions?.find(
            (transaction) => {
              return (
                transaction?.reason === values?.financeDetails?.transactions?.adhocTransactions[0]?.reason &&
                transaction?.amount === values?.financeDetails?.transactions?.adhocTransactions[0]?.amount
              );
            }
          );
          const messageId = result?.data?.identityVerificationCaseV1Update?.identityVerificationCaseV1?.messages?.find((message: any) => {
            return message?.embedding === values?.messages[0]?.embedding;
          });
          const embeddingArray = JSON.parse(values?.messages[0]?.embedding);
          let updatedEmbedding = embeddingArray.find((data: any) => {
            return (
              data.adhocPayment.reason === values?.financeDetails?.transactions?.adhocTransactions[0]?.reason &&
              data.adhocPayment.amount === values?.financeDetails?.transactions?.adhocTransactions[0]?.amount
            );
          });
          updatedEmbedding['adhocTransactionId'] = adhocTransaction?.id;
          console.log('updatedEmbedding', embeddingArray);

          await updateMessages({
            variables: {
              input: {
                id: props.caseId,
                messages: [
                  {
                    id: messageId?.id,
                    sentBy: 'internal',
                    message: values?.messages[0]?.message,
                    embedding: JSON.stringify(embeddingArray)
                  }
                ]
              }
            }
          });
        }
        message.success('Message sends successfully');
      } else {
        message.error(`Error in sending message: ${result.data?.identityVerificationCaseV1Update?.status.errorMessage}`);
      }
    } catch (error) {
      message.error(`Error in sending message: ${JSON.stringify(error)}`);
    }
  };

  const getData = async () => {
    console.log('data ', queryData);
  };

  const reloadMessages = async () => {
    await getData();
  };

  return (
    <ComponentQueryLoader
      loading={loading || staffLoading}
      error={error || staffError}
      hasData={queryData && staffData}
      hasDataComponent={
        <ChatPage
          caseData={queryData?.identityVerificationCaseV1 as CaseData}
          requestChangesFields={requestObject}
          updateMessage={reloadMessages}
          onSave={handleSave}
          canIssueRefund={staffData?.staffUserCurrent?.role?.permissions.idCasePermissions.canIssueRefunds}
          isCaseOrApplicant={props.isCaseOrApplicant}
        />
      }
    />
  );
};
